import { render, staticRenderFns } from "./modal-ai-clone.vue?vue&type=template&id=2e060e06&"
import script from "./modal-ai-clone.vue?vue&type=script&lang=js&"
export * from "./modal-ai-clone.vue?vue&type=script&lang=js&"
import style0 from "./modal-ai-clone.vue?vue&type=style&index=0&id=2e060e06&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports